import { FormattedMessage, useIntl } from "react-intl";

import PrimaryButton from "@components/buttons/PrimaryButton";
import Nbsp from "@components/Nbsp";
import styles from "@components/PurchaseHours.module.css";
import ExternalLink from "@components/typography/ExternalLink";
import useMyClient from "@hooks/useMyClient";
import { imageUrl } from "@utils/imageUtils";
import { isIosNativeApp } from "@utils/platformUtils";
import { journeyRoute } from "@utils/routeUtils";

type Props = {
  journeyId: string;
};

const PurchaseHours = ({ journeyId }: Props) => {
  const intl = useIntl();
  const myClient = useMyClient();

  return (
    <div className={styles.container}>
      <img
        alt={intl.formatMessage({ id: "accessibility.altTags.article" })}
        className={styles.shoppingCart}
        src={imageUrl("shoppingCart")}
      />
      <div className={styles.purchaseHoursContent}>
        <FormattedMessage id="models.restrictedAccess.purchaseMore" />
      </div>
      <div className={styles.purchaseHoursContent1}>
        <FormattedMessage id="models.restrictedAccess.hoursUsed" />
      </div>
      <div className={styles.buttonGroup}>
        {!isIosNativeApp() && (
          <PrimaryButton
            disabled={!myClient}
            routerLink={journeyRoute({
              journeyId,
              linkAfterJourney: "/account?purchaseHours=true",
              myClient,
              preventScroll: false
            })}
            textKey="models.restrictedAccess.purchaseHours"
          />
        )}
      </div>
      <div>
        <FormattedMessage id="pages.messages.haveAQuestion" />
        <Nbsp />
        <ExternalLink href="mailto:support@withgrayce.com">
          <FormattedMessage id="pages.messages.contactSupport" />
        </ExternalLink>
      </div>
    </div>
  );
};

export default PurchaseHours;
